module.exports = __webpack_public_path__ + "static/img/21.0321e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/21.jpg
// module id = 3xO1
// module chunks = 0